export default __webpack_public_path__ + "static/media/green-tiktok.fce45354.png";